import React from "react";
import { CountryLink } from "./Types";
import { Text } from "@amzn/storm-ui";
import {
  DesktopListComponentButton,
  DesktopListComponentItemContainer,
} from "src/components/styles/ListComponentStyling";

type CountryListDesktopProps = {
  countryLinks: CountryLink[];
  handleClick: (url: string) => void;
};

export const CountryListDesktop: React.VFC<CountryListDesktopProps> =
  ({countryLinks, handleClick}) => {
    return (
      <DesktopListComponentItemContainer>
        {countryLinks.map((countryLink) => {
          return (
            <DesktopListComponentButton
              key={countryLink.country}
              transparent={true}
              onClick={() => handleClick(countryLink.url)}
              data-takt-id={`interstitial-country-${countryLink.country}-desktop`}
              data-testid={countryLink.url}
            >
              <Text key={countryLink.country} textColor="base" fontSize="small">{countryLink.country}</Text>
            </DesktopListComponentButton>
          );
        })}
      </DesktopListComponentItemContainer>
    );
}